<template>
    <div class="exception-body access">
        <img v-if="showLogo" src="layout/images/logo-white.svg" alt="diamond-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">ACCESSO NEGATO</div>
            <div class="exception-detail">Non hai le autorizzazioni necessarie.</div>
            <router-link to="/">Torna alla Dashboard</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showLogo: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
</script>
